import React from 'react';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant: 'primary' | 'secondary';
  fullWidth?: boolean;
}

export function Button({ variant, fullWidth, style, ...rest }: ButtonProps) {
  const variantStyle: React.CSSProperties =
    variant === 'primary'
      ? { background: 'var(--primary, #96650D)', color: 'var(--primary-text, #FFFFFF)', border: 'none' }
      : { background: 'var(--surface, #FFFFFF)', color: 'var(--primary, #96650D)', border: '1px solid var(--primary, #96650D)' };

  return (
    <button
      data-variant={variant}
      style={{
        ...variantStyle,
        borderRadius: 'var(--radius-sm, 3px)',
        padding: '8px 16px',
        fontWeight: 600,
        cursor: 'pointer',
        width: fullWidth ? '100%' : undefined,
        ...style,
      }}
      {...rest}
    />
  );
}

export default Button;
